<script setup lang="ts">
import { AppFlicker } from '@libs/ui';
import type { AppFlickerSize, AppFlickerBorderRadius } from '@libs/ui';

const width: AppFlickerSize = '100%';
const height: AppFlickerSize = 'font-size-20';
const borderRadius: AppFlickerBorderRadius = 'border-radius-8';
</script>

<template>
  <div class="hotel-main-description-section-loader">
    <div class="title">
      {{ $t('planner.about_the_hotel') }}
    </div>
    <div class="flicker">
      <AppFlicker
        :width="width"
        :height="height"
        :border-radius="borderRadius"
      />
      <AppFlicker
        :width="width"
        :height="height"
        :border-radius="borderRadius"
      />
      <AppFlicker
        :width="width"
        :height="height"
        :border-radius="borderRadius"
      />
      <div class="link-flicker">
        <AppFlicker
          width="spacing-96"
          height="line-heights-18"
          border-radius="border-radius-8"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-main-description-section-loader {
  .title {
    margin-bottom: var(--spacing-16);
    color: var(--color-neutral-70);
    @include font-heading-5;
  }

  .flicker {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    .link-flicker {
      margin-top: var(--spacing-16);
    }
  }
}
</style>
